"use client";

import { useEffect } from "react";

import { DocxFileView } from "@/components/lazy-heavy-components";

export interface DocxFileViewerPageProps {
  /** Signed file-download capability URL. */
  url: string;
  /** Filename supplied by the inline link or attachment. */
  fileName: string;
  onClose: () => void;
}

/** Standalone full-viewport DOCX viewer used by chat pop-out URLs. */
export function DocxFileViewerPage({
  url,
  fileName,
  onClose,
}: DocxFileViewerPageProps) {
  useEffect(() => {
    document.title = fileName;
    return () => {
      document.title = import.meta.env.APP_NAME ?? "Layer Nine";
    };
  }, [fileName]);

  return (
    <div className="flex h-screen min-h-0 flex-col bg-background text-foreground">
      <DocxFileView
        url={url}
        fileName={fileName}
        onClose={onClose}
        className="h-full"
      />
    </div>
  );
}
